import { getRotationInfo } from '@/app/utils/helpers';
import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';

/**
 * P Image Badge Setting Handler
 */
export class ShBadgeRotateFrame extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const $self = this.getAtomTarget('read', this);

    // transform (Rotate Frame)
    const $badgeAnchor = $self.siblings('.gf_product-badge-anchor');
    const rotationTextInfo: any = getRotationInfo($badgeAnchor);
    const value: any = rotationTextInfo && rotationTextInfo.deg ? rotationTextInfo.deg : 0;
    options.$activePanel.find('#badgeRotateFrame').val(value).attr('value', value).trigger('value-change');
  }

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $atom: JQuery;
      $activePanel: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;
    const $self = this.getAtomTarget('write', this);
    let style = this.getAtomModel().style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    if (!targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      if (this.setting.options?.length) {
        for (let i = 0; i < this.setting.options.length; i++) {
          const option = this.setting.options[i];
          if (option.key == value) {
            value = option.value;
          }
        }
      }
      const degVal: any = options.$activePanel.find('#badgeRotateText').val();
      let listTransForm = '';
      const rotateDeg = degVal ? parseInt(degVal) : 0;
      let deOptions = [];
      const positionSelected = options.$activePanel.find('#badgePosition').val();
      if (positionSelected == 'center') {
        const translateX = '-50%';
        const translateY = '-50%';
        listTransForm = `rotate(${rotateDeg}deg) translate(${translateX}, ${translateY})`;
        deOptions = [
          {
            key: 'transform',
            value: listTransForm,
          },
        ];
      } else {
        listTransForm = `rotate(${rotateDeg}deg)`;
        deOptions = [
          {
            key: 'transform',
            value: listTransForm,
          },
        ];
      }
      style = HELPER.designOptions2Style($self, options.screenType, style, deOptions, targetSelector);
    }
    screenTop;
    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}
